import React, { Component } from 'react';

export default class Display_Mp_Cell_SP extends Component {
	constructor(props) {
		super(props);

		this.state = {}
	}

	render() {
		let font_size = (0.1) * this.props.cell_width;
		let pointInfo = this.props.point_info;
		let sp = null;
		if (this.props.is_movable) sp = 'Setpoint';				//special placeholder, if moving on edit layout screen has no Setpoint, will put Nan

		let fontColor = 'black';

		if (pointInfo.mode == 'A' || pointInfo.mode == 'T') {
			if (pointInfo.actual_mode == 'C') {
				sp = pointInfo.csp;
				fontColor = 'blue';
			}

			if (pointInfo.actual_mode == 'H') {
				sp = pointInfo.hsp;
				fontColor = 'red';
			}
		} else {
			if (pointInfo.mode == 'C') {
				sp = pointInfo.csp;
				fontColor = 'blue';
			}

			if (pointInfo.mode == 'H') {
				sp = pointInfo.hsp;
				fontColor = 'red';
			}
		}

		return (
			<div style={{ display: sp == null ? 'none' : 'inline-block' }}>
				<span style={{ fontSize: font_size, color: fontColor, whiteSpace: 'nowrap' }}>{sp + this.props.receiver.getString('DEG')}</span>
			</div>
		)
	}
}